import React, { memo } from "react";
import TatByPersonChart from "./TatByPersonChart";
import OverdueTasksTable from "./OverdueTasksTable";

const TatOverduePanel = ({
  tatByPersonRows = [],
  tatLoading = false,
  tatTotal = 0,
  tatPage = 1,
  tatPageSize = 10,
  onTatPaginationChange,
  overdueTaskRows = [],
  isLoading = false,
  totalItems = 0,
  currentPage = 1,
  pageSize = 10,
  onPaginationChange,
  onPersonClick,
  onOwnerClick,
  onTagClick,
  onSortChange,
  sortBy,
  sortOrder,
  teamView,
}) => (
  <div className="tat-overdue-panel">
    <TatByPersonChart
      rows={tatByPersonRows}
      isLoading={tatLoading}
      totalItems={tatTotal}
      currentPage={tatPage}
      pageSize={tatPageSize}
      onPaginationChange={onTatPaginationChange}
      onPersonClick={onPersonClick}
      teamView={teamView}
    />
    <OverdueTasksTable
      rows={overdueTaskRows}
      isLoading={isLoading}
      totalItems={totalItems}
      currentPage={currentPage}
      pageSize={pageSize}
      onPaginationChange={onPaginationChange}
      onOwnerClick={onOwnerClick || onPersonClick}
      onTagClick={onTagClick}
      onSortChange={onSortChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
    />
  </div>
);

export default memo(TatOverduePanel);

